<template>
  <lb-dialog v-model="localPendingDialog" heading="Pending approval list" width="80%" :loading="pendingLoading">
    <template v-slot:body>
      <div>
        <IndividualApprovalsList :data="pendingRequestList" @loading="$emit('pending-loading', $event)" :key="new Date().getTime()" :show-reporting-type="false" />
      </div>
    </template>
  </lb-dialog>
</template>

<script>
import IndividualApprovalsList from "../../IndividualApprovalsList.vue";

export default {
  name: 'PendingRequestsDialog',
  components: {
    IndividualApprovalsList
  },
  props: {
    value: { type: Boolean, default: false },
    pendingRequestList: { type: Array, default: () => [] },
    pendingLoading: { type: Boolean, default: false }
  },
  computed: {
    localPendingDialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  }
}
</script>